var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('p',[_vm._v("based on "),_c('a',{attrs:{"href":"https://www.trim21.cn"}},[_vm._v("some of mine api")])])])}]

export { render, staticRenderFns }